"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var FormText_1 = require("../FormText");
var Input = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'text' : _b, label = _a.label, helpText = _a.helpText, errorText = _a.errorText, props = __rest(_a, ["type", "label", "helpText", "errorText"]);
    var id = ("input-" + label).replace(/\s/g, '-').toLowerCase();
    var css = ['form-control'];
    if (errorText)
        css.push('border border-danger');
    return (jsx_runtime_1.jsxs("div", __assign({ className: "form-group" }, { children: [jsx_runtime_1.jsx("label", __assign({ className: "text-capitalize mr-2", htmlFor: id }, { children: label }), void 0),
            errorText && jsx_runtime_1.jsx(FormText_1.FormText.Error, { className: "ml-2", text: "(" + errorText + ")" }, void 0),
            jsx_runtime_1.jsx("input", __assign({ id: id, type: type, className: css.join(' ') }, props), void 0),
            helpText && jsx_runtime_1.jsx(FormText_1.FormText.Help, { text: helpText }, void 0)] }), void 0));
};
exports.Input = Input;
//# sourceMappingURL=index.js.map